//https://blog.bitsrc.io/build-a-login-auth-app-with-mern-stack-part-2-frontend-6eac4e38ee82
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setPassword } from "./actions/authActions";

import {Helmet} from "react-helmet";

import store from "./store";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";

//import classnames from "classnames"; //FIXME: REM / UNINSTALL?

import {Card, PageHeader, Form, Input, Checkbox, Button} from 'antd';

const DASHBOARD_PATH = "/search"; //FIXME: DO BETTER, GLOBAL VAR? OR INVERSE PROTECTED ROUTE?

//FIXME: BETTER NAMES FOR THIS AND PASSWORDRESET
class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      password2: "",
      errors: {}
    };

    if (this.props.match.params.token) //SHould always be true FIXME: DO BETTER //localStorage.jwtToken) {
    {
        // Set auth token header auth
      const token = "Bearer " + this.props.match.params.token;//localStorage.jwtToken;
      setAuthToken(token);
      // Decode token and get user info and exp
      const decoded = jwt_decode(token);
      // Set user and isAuthenticated
      store.dispatch(setCurrentUser(decoded));

      // Check for expired token
      const currentTime = Date.now() / 1000; // to get in milliseconds
      if (decoded.exp < currentTime)
      {
        console.log("AHHHHH LOGGED!!!!");
        // Logout user
        //store.dispatch(logoutUser()); //FIXME: DO BETTER B/C WRONG TYPE
        // Redirect to login
        window.location.href = "./login";
      }
      else
      {
          //store.dispatch(getUserNotes());
      }
    }
    //END AUTH

  }

  componentDidMount() {
  // If logged in and user navigates to Login page, should redirect them to dashboard
  if (this.props.auth.isAuthenticated) {
    this.props.history.push(DASHBOARD_PATH);
  }
}
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors
      });
    }
  }

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  //FIXME: MAKE USERNAMES DISTINCT
  onSubmit = e => {
    //e.preventDefault(); //FIXME: WHY BROKEN ON ANT?
    const newUser = {
      password: this.state.password,
      password2: this.state.password2,
    };
    this.props.setPassword(newUser, this.props.history);
  };

//FIXME: VERIFY CLASS
  getPageHeader = (name) => {
    return (
      <PageHeader className="note-header" title={name} />
    )
  }

  getSubtitle = () => {
    return (
      <div style={{color:'black'}}>
        Already have an account? <Link to="/login">Log in</Link>
      </div>
    )
  }

  getEmailErrors = () => {
    return this.state.errors.email;
  }

  getEmailStatus = () => {
    return (this.getEmailErrors()) ? 'error' : 'success';
  }

  getPasswordErrors = () => {
    return this.state.errors.password;
  }

  getPasswordStatus = () => {
    return (this.getPasswordErrors()) ? 'error' : 'success';
  }

  //FIXME: VERIFY VALID TOKEN
  //FIXME: Make sure both filled locally.
  render() {
    const { errors } = this.state;

    return (
      <>
      <Helmet>
        <title>XING | Change Password</title>
      </Helmet>
      <Card className="login-form" title={this.getPageHeader("Reset Password")} scrollToFirstError>
        <Form  layout="vertical" onFinish={(e) => {this.onSubmit(e)}}>

          <Form.Item name="password" label="Password" validateStatus={this.getPasswordStatus()} help={this.getPasswordErrors()}>
            <Input.Password type="password" onChange={this.onChange} placeholder="" />
          </Form.Item>

          <Form.Item name="password2" label="Confirm Password" validateStatus={(errors.password2) ? 'error' : 'success'} help={errors.password2}>
            <Input.Password type="password" onChange={this.onChange} placeholder="" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Reset
            </Button>
        </Form.Item>
        </Form>
      </Card>
      </>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { setPassword }
)(withRouter(ChangePassword));
